import Vue from "vue";
import Modal from "./components/modal/modal";

Vue.component("my-modal", Modal);
